module.exports = __webpack_public_path__ + "assets/img/Pioneer_004.99515086-ps.jpg";